import type { FC } from 'react';

interface SimpleStatisticCardProps {
    cardTitle: string;
    cardSubtitle?: string;
    cardDescription?: string;
    cardSize?: 'sm' | 'md' | 'lg';
    className?: string;
}

const SimpleStatisticCard: FC<SimpleStatisticCardProps> = ({ cardTitle, cardSubtitle, cardDescription, cardSize = 'md', className }) => {
    return (
        <div className={`simple-statistic-card size-${cardSize} ${className}`}>
            <div className="card-header">
                <div className="card-title">{cardTitle}</div>
                {cardSubtitle && (
                    <div className="card-subtitle">{cardSubtitle}</div>
                )}
            </div>
            {cardDescription && (
                <div className="card-description">
                    {cardDescription}
                </div>
            )}
        </div>
    );
};

export default SimpleStatisticCard;
